import React, { useState } from "react";
import { Star } from "lucide-react";
import { surveyAPI } from '@/lib/api';

export default function SurveyPage() {

  /* ================= TOKEN ================= */

  const params = new URLSearchParams(window.location.search);
  const token = params.get("token");

  /* ================= STATE ================= */

  const [rating, setRating] = useState(5);
  const [serviceQuality, setServiceQuality] = useState(5);
  const [staffBehavior, setStaffBehavior] = useState(5);
  const [onTime, setOnTime] = useState(5);
  const [comment, setComment] = useState("");
  const [recommend, setRecommend] = useState(true);

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  /* ================= SUBMIT ================= */

  const submitSurvey = async () => {

    if (!token) {
      alert("Geçersiz anket linki");
      return;
    }

    try {
      setLoading(true);

      await surveyAPI.submit({
        token,
        rating,
        service_quality: serviceQuality,
        staff_behavior: staffBehavior,
        on_time: onTime,
        comment,
        would_recommend: recommend,
      });

      setSuccess(true);

    } catch (err) {
      alert(
        err?.response?.data?.detail ||
        "Anket gönderilirken hata oluştu"
      );
    } finally {
      setLoading(false);
    }
  };

  /* ================= SUCCESS ================= */

  if (success) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 p-6">

        <div className="bg-white shadow-xl rounded-2xl p-10 text-center max-w-md">

          <h2 className="text-2xl font-bold text-green-600 mb-4">
            Teşekkür ederiz 🙏
          </h2>

          <p className="text-gray-600">
            Görüşleriniz hizmet kalitemizi artırmamıza yardımcı oluyor.
          </p>

          <a
            href="https://g.page/r/CX91oJrq6Dw3EAE/review"
            target="_blank"
            rel="noreferrer"
            className="mt-6 inline-block bg-[#EA580C] text-white px-6 py-3 rounded-lg font-semibold"
          >
            Google’da Yorum Bırak ⭐
          </a>

        </div>
      </div>
    );
  }

  /* ================= UI ================= */

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-6">

      <div className="bg-white shadow-xl rounded-2xl p-8 w-full max-w-xl">

        <h1 className="text-2xl font-bold text-center text-[#00205B] mb-6">
          Memnuniyet Anketi
        </h1>

        <Rating label="Genel Memnuniyet" value={rating} setValue={setRating} />
        <Rating label="Hizmet Kalitesi" value={serviceQuality} setValue={setServiceQuality} />
        <Rating label="Personel Davranışı" value={staffBehavior} setValue={setStaffBehavior} />
        <Rating label="Zamanında Hizmet" value={onTime} setValue={setOnTime} />

        {/* COMMENT */}

        <div className="mt-6">
          <label className="font-semibold text-gray-700">
            Yorumunuz
          </label>

          <textarea
            className="w-full border rounded-lg p-3 mt-2 focus:outline-none focus:ring-2 focus:ring-[#EA580C]"
            rows={4}
            placeholder="Hizmetimiz hakkında görüşlerinizi yazabilirsiniz..."
            value={comment}
            onChange={(e) => setComment(e.target.value)}
          />
        </div>

        {/* RECOMMEND */}

        <div className="mt-6">
          <label className="font-semibold text-gray-700 block mb-2">
            Bizi tavsiye eder misiniz?
          </label>

          <div className="flex gap-4">

            <button
              onClick={() => setRecommend(true)}
              className={`px-4 py-2 rounded-lg border ${recommend ? "bg-green-500 text-white" : "bg-white"
                }`}
            >
              Evet
            </button>

            <button
              onClick={() => setRecommend(false)}
              className={`px-4 py-2 rounded-lg border ${!recommend ? "bg-red-500 text-white" : "bg-white"
                }`}
            >
              Hayır
            </button>

          </div>
        </div>

        {/* SUBMIT */}

        <button
          onClick={submitSurvey}
          disabled={loading}
          className="w-full mt-8 bg-[#00205B] text-white py-3 rounded-lg font-semibold hover:bg-[#001a4d] transition"
        >
          {loading ? "Gönderiliyor..." : "Gönder"}
        </button>

      </div>
    </div>
  );
}

/* ================= RATING ================= */

function Rating({ label, value, setValue }) {
  return (
    <div className="mb-6">

      <label className="font-semibold text-gray-700 block mb-2">
        {label}
      </label>

      <div className="flex gap-2">

        {[1, 2, 3, 4, 5].map((star) => (
          <Star
            key={star}
            onClick={() => setValue(star)}
            className={`cursor-pointer transition ${star <= value
              ? "text-yellow-400 fill-yellow-400"
              : "text-gray-300"
              }`}
          />
        ))}

      </div>
    </div>
  );
}
